/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import TableOrder from "components/Tables/TableOrder";
import React, { useContext, useEffect, useState } from "react";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationHeader from "../ConfigurationHeader";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { __Country } from "request/configuration/_Country";
import Pagination from "components/Pagination/Pagination";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import environment from "constants/apiConst";

import { useSelector } from "react-redux";
import { __GetData } from "request/Petitions/__Get";
import TBodyPort from "../tables/TBodyPort";
import FormPort from "../FormShow/FormPort";
import { __PostFormData } from "request/Petitions/__Post";
import FormViewPort from "../FormShow/FormViewPort";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";

const Port = () => {
  const {
    setRequestEdit,
    setRequestCreate,
    setRequestDelete,
    setFormEdit,
    setFormShow,
    update
  } = useContext(ConfigurationCRUDContext);
  const [currentPage, setCurrentPage] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);
  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);
  const navigate = useNavigate();

  const formEditSub = () => {
    return <FormPort />;
  };

  const countryView = () => {
    return <FormViewPort />;
  };


  useEffect(() => {
    setFormEdit(formEditSub);
    setFormShow(countryView);
    if (q) {
      setRequestEdit(environment.COUNTRY_UPDATE);
      setRequestCreate(environment.COUNTRY_CREATE);
      setRequestDelete(environment.COUNTRY_DELETE);
    }
  }, [q]);

  useEffect(() => {
    setFormEdit(formEditSub);
    setFormShow(countryView);
    setRequestEdit(environment.UPDATE_PORT);
    setRequestCreate(environment.CREATE_PORT);
    setRequestDelete(environment.DELETE_PORT);
  }, [update]);

  const Title = [
    { name: "Puerto", order: null },
    { name: "Estado", order: null },
    { name: "Acciones", order: "" }
  ];

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configPort", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.GET_PORT_PAGE,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <>
      <SectionContainerGene>
        <ConfigurationHeader title="Puerto"></ConfigurationHeader>

        <TableOrder
          thead={Title}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TBodyPort}
        />
        <Pagination
          page={page}
          setPage={setPage}
          maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
          loading={isLoading}
        />
      </SectionContainerGene>
    </>
  );
};

export default Port;
